module.exports = __webpack_public_path__ + "img/logos.c770c719.png";